import EventEmitter from './EventEmitter'

/**
 * Drives the render loop and emits `tick` every animation frame.
 * `delta` and `elapsed` are in milliseconds.
 */
export default class Time extends EventEmitter {
  public readonly start: number
  public current: number
  public elapsed: number
  public delta: number

  private rafId = 0
  private running = true

  constructor() {
    super()

    this.start = performance.now()
    this.current = this.start
    this.elapsed = 0
    this.delta = 16 // sensible default for the first frame

    // Kick off on the next frame so listeners attached after construction fire.
    this.rafId = window.requestAnimationFrame(this.tick)
  }

  private tick = (): void => {
    if (!this.running) return

    // Schedule the next frame FIRST so a thrown error in a `tick` listener can
    // never kill the render loop (it would just log and keep going).
    this.rafId = window.requestAnimationFrame(this.tick)

    const current = performance.now()
    this.delta = current - this.current
    this.current = current
    this.elapsed = this.current - this.start

    try {
      this.trigger('tick')
    } catch (error) {
      console.error('[loop] error in tick handler:', error)
    }
  }

  public stop(): void {
    this.running = false
    window.cancelAnimationFrame(this.rafId)
  }
}
